import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Sociedades, Cliente } from '../interfaces/beans.interface';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SociedadService {

  url = environment.url2 + '/sociedad';
  urlCodigoPostal = environment.url3 + '/codigoPostal';
  url12 = environment.url2 + '/usuarioRolSociedad';
  constructor(private http: HttpClient) {}

  count() {
    let headers = new HttpHeaders()
    .append('Content-Type', 'application/json')
    .append('Autorizzazione', localStorage.getItem('token'));
    let elemento =  this.http.get(`${ this.url }/count`, { headers }).pipe( map( data => data));
    return elemento;
  }

  //NUEVOS SERVICIOS
  getAllAccesoUsuarioPag(paginaActual: number, registrosPorPagina: number, rfcUsuario: string) {
    let headers = new HttpHeaders()
    .append('Content-Type', 'application/json')
    .append('Autorizzazione', localStorage.getItem('token'));
    return this.http.get(`${ this.url }/sociedadesAcceso?pagina=${ paginaActual }&registros=${ registrosPorPagina }&rfc=${ rfcUsuario }`, { headers }).pipe( map( data => data));
  }

  countAccesoUsuario(rfcUsuario: string) {
    let headers = new HttpHeaders()
    .append('Content-Type', 'application/json')
    .append('Autorizzazione', localStorage.getItem('token'));
    let elemento =  this.http.get(`${ this.url }/countAcceso/${ rfcUsuario }`, { headers }).pipe( map( data => data));
    return elemento;
  }

  getAllAccesoUsuario(rfcUsuario: string) {
    let headers = new HttpHeaders()
    .append('Content-Type', 'application/json')
    .append('Autorizzazione', localStorage.getItem('token'));
    let elemento =  this.http.get(`${ this.url }/all/SociedadesListAcceso/${ rfcUsuario }`, { headers }).pipe( map( data => data));
    return elemento;
  }

  //

  getAll(paginaActual: number, registrosPorPagina: number) {
    let headers = new HttpHeaders()
    .append('Content-Type', 'application/json')
    .append('Autorizzazione', localStorage.getItem('token'));
    return this.http.get(`${ this.url }/all?pagina=${ paginaActual }&registros=${ registrosPorPagina }`, { headers }).pipe( map( data => data));
  }

  getAllUsuariosSociedad(paginaActual: number, registrosPorPagina: number, rfcSociedad: string) {
    let headers = new HttpHeaders()
    .append('Content-Type', 'application/json')
    .append('Autorizzazione', localStorage.getItem('token'));
    return this.http.get(`${ this.url12 }/allUsuarios?pagina=${ paginaActual }&registros=${ registrosPorPagina }&sociedad=${ rfcSociedad }`, { headers }).pipe( map( data => data));
  }

  getAllList() {
    let headers = new HttpHeaders()
    .append('Content-Type', 'application/json')
    .append('Autorizzazione', localStorage.getItem('token'));
    let sociedades = this.http.get(`${ this.url}/all/SociedadesList`, { headers }).pipe( map( data => data));
    return sociedades;
  }

  find(rfcSociedad: string) {
    let headers = new HttpHeaders()
    .append('Content-Type', 'application/json')
    .append('Autorizzazione', localStorage.getItem('token'));
    console.log("******************** HEaders FIND");
    console.log(headers);
    console.log('/find/ '+rfcSociedad);
    let consult = this.http.get(`${ this.url }/find/${ rfcSociedad }`, { headers }).pipe( map( data => data));
    return consult;
  }

  add(empresa: Sociedades) {
    let cliente:  Cliente = { id: localStorage.getItem('idCliente')};
    //empresa.cliente = cliente;
    let body = JSON.stringify(empresa);
    console.log(body);
    let headers = new HttpHeaders()
    .append('Content-Type', 'application/json')
    .append('Autorizzazione', localStorage.getItem('token'));
    return this.http.post(`${ this.url }/add?cliente=${ localStorage.getItem('idCliente') }&usuario=${ localStorage.getItem('idUsuario') }`, body, { headers }).pipe( map( data => data));
  }

  update(empresa: Sociedades) {
    let cliente:  Cliente = { id: localStorage.getItem('idCliente')};
    //empresa.cliente = cliente;
    let body = JSON.stringify(empresa);
    let headers = new HttpHeaders()
    .append('Content-Type', 'application/json')
    .append('Autorizzazione', localStorage.getItem('token'));
    return this.http.put(`${ this.url }/update?cliente=${ localStorage.getItem('idCliente') }&usuario=${ localStorage.getItem('idUsuario') }`, body, { headers }).pipe( map( data => data));
  }

  delete(idSociedad: string) {
    let headers = new HttpHeaders()
    .append('Content-Type', 'application/json')
    .append('Autorizzazione', localStorage.getItem('token'));
    return this.http.delete(`${ this.url }/delete/${ idSociedad }`, { headers }).pipe( map( data => data));
  }

  //DOMICILIO
    codigoPostal(codigo: number) {
    let headers = new HttpHeaders()
    .append('Content-Type', 'application/json')
    // .append('Access-Control-Allow-Origin', environment.urlLocal);
    return this.http.get(`${ this.urlCodigoPostal }/find/${ codigo }`, { headers }).pipe( map( data => data));
    }

    //SOCIEDADES VALIDAS PARA MODIFICAR
    getAccesSociedad(rfcUsuario: string) {
      let headers = new HttpHeaders()
      .append('Content-Type', 'application/json')
      .append('Autorizzazione', localStorage.getItem('token'));
      let sociedades = this.http.get(`${ this.url}/acceSociedades/${ rfcUsuario }`, { headers }).pipe( map( data => data));
      return sociedades;
    }

    //SOCIEDADES QUE PUEDEN SER MODIFICADAS SOLOPOR ADM. UNICO,
    //PRESIDENTE DEL CONSEJO, EL QUE CREO AL EMPRESA Y TRACER+
    getModifySociedad(rfcUsuario: string) {
      let headers = new HttpHeaders()
      .append('Content-Type', 'application/json')
      .append('Autorizzazione', localStorage.getItem('token'));
      let sociedades = this.http.get(`${ this.url}/sociedadesModify/${ rfcUsuario }`, { headers }).pipe( map( data => data));
      return sociedades;
    }
}
